import { z } from 'zod';
import { WorkflowWriteBackMode } from 'libs/end-to-end/src/types/databases/workflows/workflow-write-back-mode';
import { WriteBackChartHopStrategy } from 'libs/end-to-end/src/types/databases/workflows/promotion-readiness-score-write-back/sources/chart-hop';

export const WorkflowPromotionReadinessExplanationWriteBackStrategy =
  WriteBackChartHopStrategy;

export type WorkflowPromotionReadinessExplanationWriteBackStrategy = z.infer<
  typeof WorkflowPromotionReadinessExplanationWriteBackStrategy
>;

/**
 * Details for a workflow that writes back promotion readiness explanation.
 */
export const WorkflowPromotionReadinessExplanationWriteBackDetails = z.object({
  type: z.literal('promotionReadinessExplanationWriteBack'),

  /**
   * The strategy for writing back.
   */
  strategy: WorkflowPromotionReadinessExplanationWriteBackStrategy.optional(),

  /**
   * The mode for writing back.
   */
  mode: WorkflowWriteBackMode.optional(),

  /**
   * The minimum readiness rating for an employee to be considered for writing back.
   */
  minReadinessRating: z.number().optional(),

  /**
   * The maximum amount of readiness scores to write back. This is used to limit the amount of data
   * that is written back to the target system, mainly for testing purposes.
   */
  numberOfSamplesToSend: z.number().optional(),

  /**
   * The format for the explanation text.
   */
  format: z.enum(['long', 'short']).optional(),
});

export type WorkflowPromotionReadinessExplanationWriteBackDetails = z.infer<
  typeof WorkflowPromotionReadinessExplanationWriteBackDetails
>;
